import React from 'react';

import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {ElementMouseEvent} from 'util/Types';

import ClickableIcon, {ClickableIconStyle} from './ClickableIcon';

interface AddIconProps {
  onClick?: (e: ElementMouseEvent) => void;
  disabled?: boolean;
  altText?: string;
  /**
   * If this is not provided, the icon will be given left margin. Otherwise, only the provided class will be
   * applied.
   */
  className?: string;
  dataTestAttrs?: DataTestAttrs;
}

export default function AddIcon({
  onClick,
  disabled = false,
  altText,
  className = 'u-small-spacing-left',
  dataTestAttrs,
}: AddIconProps): JSX.Element {
  return (
    <ClickableIcon
      icon="compose"
      onClick={onClick}
      disabled={disabled}
      iconStyle={ClickableIconStyle.POSITIVE}
      altText={altText}
      className={className}
      dataTestAttrs={dataTestAttrs}
    />
  );
}
